import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { NumberFormat } from '@ecp/common/src/utils/utils';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { userInfoState } from '@fo-recoil/common/user/atom';
import { getIsLogin } from '@fo-recoil/common/user/selector';
import skypassMileageApi from '@fo-apis/price/skypassMileageApi';
import {
  Container,
  VerticalDivider,
  MileageTextBox,
  CloseButtonWrap,
  ShowMileageButton,
} from '@ecp/fo/sites/skypass/styles/gnb/SkypassGnbHeaderBottomUserInfoStyles';

export default function SkypassGnbHeaderBottomUserInfo() {
  const [isClose, setIsClose] = useState(false);
  const [showMileage, setShowMileage] = useState(false);
  const [mileageUsage, setMileageUsage] = useState(0);
  const userInfo = useRecoilValue(userInfoState);
  const isLogin = useRecoilValue(getIsLogin);
  const location = useLocation();

  useEffect(() => {
    setShowMileage(false);
  }, [location.pathname]);

  function close() {
    setIsClose(true);
  }

  async function onClickShowMileageButton() {
    await fetch();

    setShowMileage(true);
  }

  async function fetch() {
    if (isLogin) {
      const { result } = await skypassMileageApi.getMileage();

      const { currentMileage } = result;

      setMileageUsage(currentMileage);
    }
  }

  if (!isClose && isLogin) {
    return (
      <Container>
        <CloseButtonWrap onClick={close} />

        <FlexBox gap={'12px'}>
          <TextBox size={'12px'}>SKYPASS 회원번호</TextBox>
          <TextBox size={'16px'} style={{ fontWeight: 800 }}>
            {userInfo?.employNumber}
          </TextBox>
        </FlexBox>

        <VerticalDivider />

        <FlexBox gap={'4px'}>
          {showMileage ? (
            <>
              <TextBox size={'12px'}>보유 마일리지</TextBox>
              <MileageTextBox size={'12px'}>
                <b style={{ fontWeight: 800, fontSize: '16px' }}>{NumberFormat(mileageUsage)}</b> 마일
              </MileageTextBox>
            </>
          ) : (
            <ShowMileageButton onClick={onClickShowMileageButton}>보유 마일리지 조회하기</ShowMileageButton>
          )}
        </FlexBox>
      </Container>
    );
  } else {
    return null;
  }
}
